module.exports = __webpack_public_path__ + "img/han_site2_12f.f873bb4a.jpg";